/**
 * @generated SignedSource<<79180bfb55ea4c482557101395fdb561>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATInternalUserNameUpdateInput = {
  id: string;
  userName: string;
};
export type InternalUserNameUpdateDialog_internalUserNameUpdateMutation$variables = {
  input: MATInternalUserNameUpdateInput;
};
export type InternalUserNameUpdateDialog_internalUserNameUpdateMutation$data = {
  readonly internalUserNameUpdate: {
    readonly id: string;
    readonly userName: string;
  };
};
export type InternalUserNameUpdateDialog_internalUserNameUpdateMutation = {
  response: InternalUserNameUpdateDialog_internalUserNameUpdateMutation$data;
  variables: InternalUserNameUpdateDialog_internalUserNameUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATInternalUser",
    "kind": "LinkedField",
    "name": "internalUserNameUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalUserNameUpdateDialog_internalUserNameUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternalUserNameUpdateDialog_internalUserNameUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c252330fb34f29e38ef0336648f23ac3",
    "id": null,
    "metadata": {},
    "name": "InternalUserNameUpdateDialog_internalUserNameUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation InternalUserNameUpdateDialog_internalUserNameUpdateMutation(\n  $input: MATInternalUserNameUpdateInput!\n) {\n  internalUserNameUpdate(input: $input) {\n    id\n    userName\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b5a335bbc9182ebcca99b9cc0d437c9";

export default node;
